
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { Icons } from './icons.type'

@Component({
    selector: 'icons-component',
    templateUrl: './icons.component.html',
    styleUrls: ['./icons.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: []
})
export class IconsComponent {
  @Input({ required: true }) public iconName?: string
  @Input() public stroke?: string
  @Input() public fill?: string
  @Input() public innerFill?: string
  @Input() public width?: string
  @Input() public height?: string
  public Icons = Icons
}
